module.exports = __webpack_public_path__ + "media/assets/images/flags/jm-c3313ab790341c56bbd4fe1e4beed45a.svg";